import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastService } from '../common/toast.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const toastService = inject(ToastService);

  if (isPlatformBrowser(platformId)) {
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('userRole') ? atob(localStorage.getItem('userRole')!) : '';
    const status = localStorage.getItem('userStatus') ? atob(localStorage.getItem('userStatus')!) : '';

    if (token) {
      const expectedRoles = route.data?.['roles'] as string[];
      const expectedStatuses = route.data?.['statuses'] as string[];

      // 🚫 ROLE MISMATCH HANDLING
      if (expectedRoles && !expectedRoles.includes(role)) {
        if (role === 'admin' && expectedRoles.includes('user')) {
          toastService.showToast(
            'You are logged in as admin. Please login with member credentials to access this page.',
            'danger'
          );
        } 
        else if (role === 'state_association_admin' && expectedRoles.includes('user')) {
          toastService.showToast(
            'You are logged in as State Association Admin. Please login with member credentials to access this page.',
            'danger'
          );
        }
        else if (role === 'user' && expectedRoles.includes('state_association_admin')) {
          toastService.showToast(
            'You are logged in as a Member. Please login with State Association Admin credentials to access this page.',
            'danger'
          );
        } 
        else {
          router.navigateByUrl('/unauthorized', { replaceUrl: true });
        }
        return false;
      }

      // 🚫 STATUS MISMATCH HANDLING
      if (expectedStatuses && !expectedStatuses.includes(status)) {
        if (status === 'created') {
          router.navigateByUrl('/user-not-aproved', { replaceUrl: true });
        } else {
          router.navigateByUrl('/unauthorized', { replaceUrl: true });
        }
        return false;
      }

      return true; // ✅ All good
    }

    // 🚫 NOT LOGGED IN
    localStorage.setItem('redirectUrl', state.url);
    toastService.showToast('To visit this page, you need to log in.', 'success');
    router.navigateByUrl('', { replaceUrl: true });
    return false;
  }

  return false;
};
